/** Entry point. ADR-0006: a static SPA, so this is the whole bootstrap — there is no server. */

import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { MotionConfig } from "motion/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { onSessionLost } from "./api/client";
import { createQueryClient } from "./api/queryClient";
import { handleSessionLost } from "./api/sessionEnded";
import { ToastRegion } from "./components/ui/Toast";
import { router } from "./router";
import { applyStoredTheme } from "./theme";
import "./tokens.css";

// Beside `public/theme-init.js` (which runs before first paint): the stored light/dark choice is on
// <html> before anything renders, even where that file was not loaded.
applyStoredTheme();

// Defaults and the reasons for each (no retries, always stale, and **always asking** even when the
// browser says it is offline, so a lost connection is a failed read and not a paused one): `api/queryClient.ts`.
const queryClient = createQueryClient();

/** A 401 from any endpoint means this session is over, so the shell shows the sign-in form — with a
 * sentence saying why. The ordering argument and the idempotence argument are in `handleSessionLost`. */
onSessionLost(() => handleSessionLost(queryClient));

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Gate 37: every `motion` component honours prefers-reduced-motion, whether or not its author
          remembered `useReducedMotion` (transforms and layout animation are switched off; opacity is kept). */}
      <MotionConfig reducedMotion="user">
        <RouterProvider router={router} />
        <ToastRegion />
      </MotionConfig>
    </QueryClientProvider>
  </StrictMode>,
);
